/* ==========================================================================
   KBS Favorites - UI-Anbindung (v3)
   Zaehler-Badge im Header und Herz-Buttons an den Produktkarten.

   Bewusst getrennt von kbs-favorites.js: dort liegt nur der Store,
   hier nur das DOM. Der Store laeuft auch ohne diese Datei.

   Warum kein einmaliges querySelector beim Start:
   Der Header wird vom Theme neu gerendert (Section-Reload im Editor,
   Node-Updates bei Seitenwechseln). Ein einmal gemerkter Knoten waere
   danach verwaist. Deshalb wird bei jedem Update neu abgefragt.
   ========================================================================== */
(function () {
  'use strict';

  var COUNT_SEL = '[data-kbs-fav-count]';
  var WRAP_SEL = '[data-kbs-fav-wrap]';
  var BTN_SEL = '[data-kbs-fav-toggle]';
  var LIMIT = 99;

  var cfg = window.KBS_FAVS_CONFIG || {};

  var LABELS = {
    add: cfg.labelAdd || 'Zu Favoriten hinzufügen',
    remove: cfg.labelRemove || 'Aus Favoriten entfernen'
  };

  function paint(count) {
    var text = count > LIMIT ? LIMIT + '+' : String(count);

    document.querySelectorAll(COUNT_SEL).forEach(function (el) {
      el.textContent = count > 0 ? text : '';
    });

    document.querySelectorAll(WRAP_SEL).forEach(function (el) {
      el.classList.toggle('kbs-fav--has-items', count > 0);
      var label = el.getAttribute('data-kbs-fav-label') || '';
      var link = el.closest('a') || el;
      if (label) link.setAttribute('aria-label', label + ': ' + count);
    });

    paintButtons();
  }

  /* ---------- Geklonte Karten korrigieren --------------------------------

     Der Custom-Filter und die Favoriten-Seite bauen ihre Karten nicht neu,
     sondern klonen eine echte Karte aus dem Grid und tauschen den Inhalt
     aus. Was dabei leicht vergessen wird, ist die Produkt-ID am Herz: der
     Klon traegt die ID der VORLAGENKARTE.

     Sichtbar wird das erst spaet - alle Karten zeigen dann den Zustand ein
     und desselben fremden Produkts, und ein Klick merkt das falsche Set.

     Statt die Korrektur in jede Klon-Funktion einzeln zu schreiben (und sie
     beim naechsten Grid wieder zu vergessen), prueft dieses Skript sie hier
     zentral: Der Produktlink der Karte sagt, welches Produkt wirklich
     gezeigt wird. Weicht er vom Handle am Herz ab, ist der Button veraltet.

     Die fehlende ID kommt aus dem filterdata-Feed, der Handle und ID
     enthaelt. Geladen wird er nur, wenn tatsaechlich ein veralteter Button
     gefunden wurde - auf normalen Collection-Seiten passiert das nie. */

  var handleMap = null;
  var mapPromise = null;

  function handleFromUrl(url) {
    return String(url || '').split('?')[0].replace(/\/+$/, '').split('/').pop();
  }

  function cardHandle(btn) {
    var card = btn.closest('.product-grid__item, product-card, .product-card');
    var link = card && card.querySelector('a[href*="/products/"]');
    return link ? handleFromUrl(link.getAttribute('href')) : '';
  }

  /* XHR statt fetch: window.fetch ist in diesem Theme von einer
     Drittanbieter-App ueberschrieben. */
  function feedPage(url) {
    return new Promise(function (resolve, reject) {
      var x = new XMLHttpRequest();
      x.open('GET', url, true);
      x.setRequestHeader('Accept', 'text/html');
      x.onload = function () {
        if (x.status < 200 || x.status >= 300) { reject(new Error('HTTP ' + x.status)); return; }
        try { resolve(JSON.parse(x.responseText)); } catch (e) { reject(e); }
      };
      x.onerror = function () { reject(new Error('feed failed')); };
      x.send();
    });
  }

  function loadMap() {
    if (mapPromise) return mapPromise;
    if (!cfg.feedUrl) return null;

    mapPromise = feedPage(cfg.feedUrl).then(function (first) {
      var map = {};
      var collect = function (list) {
        (list || []).forEach(function (p) {
          var h = handleFromUrl(p.u);
          if (h && p.id) map[h] = p.id;
        });
      };
      collect(first.products);

      var chain = Promise.resolve();
      for (var n = 2; n <= (first.pages || 1); n++) {
        (function (page) {
          chain = chain.then(function () {
            return feedPage(cfg.feedUrl + '&page=' + page).then(function (r) {
              collect(r.products);
            });
          });
        })(n);
      }
      return chain.then(function () { return map; });
    }).catch(function (e) {
      /* Ohne Karte bleibt es beim bisherigen Verhalten - lieber ein
         falscher Herzzustand als eine kaputte Seite. */
      console.warn('[KBS favs] Handle-Karte nicht ladbar', e);
      mapPromise = null;
      return null;
    });

    return mapPromise;
  }

  function repair(stale) {
    var run = handleMap ? Promise.resolve(handleMap) : loadMap();
    if (!run) return;

    run.then(function (map) {
      if (!map) return;
      handleMap = map;

      var changed = false;
      stale.forEach(function (entry) {
        var id = map[entry.handle];
        if (!id) return;
        entry.btn.setAttribute('data-kbs-fav-product', id);
        entry.btn.setAttribute('data-kbs-fav-handle', entry.handle);
        changed = true;
      });

      if (changed) paintButtons();
    });
  }

  /* Zustand aller sichtbaren Herz-Buttons setzen. Wird bei jeder Aenderung
     und nach jedem DOM-Update neu durchlaufen. */
  function paintButtons() {
    if (!window.KBSFavs) return;

    var stale = [];

    document.querySelectorAll(BTN_SEL).forEach(function (btn) {
      var own = btn.getAttribute('data-kbs-fav-handle') || '';
      var real = cardHandle(btn);
      if (own && real && own !== real) {
        stale.push({ btn: btn, handle: real });
      }

      var id = parseInt(btn.getAttribute('data-kbs-fav-product'), 10);
      if (!id) return;
      var on = window.KBSFavs.has(id);
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      var label = on ? LABELS.remove : LABELS.add;
      btn.setAttribute('aria-label', label);
      btn.setAttribute('title', label);
    });

    if (stale.length) repair(stale);
  }

  function current() {
    return window.KBSFavs ? window.KBSFavs.count() : 0;
  }

  function start() {
    if (!window.KBSFavs) {
      /* Engine noch nicht da - einmal nachfassen, dann aufgeben */
      window.setTimeout(start, 200);
      return;
    }

    window.KBSFavs.subscribe(function (event) {
      paint(event && event.detail ? event.detail.count : current());
    });

    /* Header wurde neu gerendert: Badge erneut setzen. */
    document.addEventListener('shopify:section:load', function () {
      paint(current());
    });

    /* Klicks per Delegation am document, nicht pro Button. Die Karten im
       Filter-Grid und in der Predictive Search werden nach jedem Rendern
       ersetzt; direkt gebundene Listener waeren danach verwaist.

       capture:true ist noetig, damit wir VOR dem Kartenlink drankommen.
       preventDefault und stopPropagation verhindern, dass der Klick als
       Navigation zur Produktseite durchschlaegt. */
    document.addEventListener('click', function (event) {
      var target = event.target instanceof Element ? event.target : null;
      if (!target) return;
      var btn = target.closest(BTN_SEL);
      if (!btn) return;

      event.preventDefault();
      event.stopPropagation();

      /* Sicherheitsnetz: Wurde der Button geklont und noch nicht korrigiert,
         zeigt sein Handle auf ein anderes Produkt als die Karte. Dann lieber
         nichts tun als das falsche Set merken - die Korrektur laeuft bereits
         und der naechste Klick sitzt. */
      var own = btn.getAttribute('data-kbs-fav-handle') || '';
      var real = cardHandle(btn);
      if (own && real && own !== real) {
        repair([{ btn: btn, handle: real }]);
        return;
      }

      var id = parseInt(btn.getAttribute('data-kbs-fav-product'), 10);
      if (!id || !window.KBSFavs) return;
      window.KBSFavs.toggle(id, own || real);
    }, true);

    /* Ein Beobachter fuer das ganze Dokument statt nur den Header: neue
       Karten koennen ueberall auftauchen - Filter-Grid, Predictive Search,
       Favoriten-Seite, nachgeladene Empfehlungen. Die Auswertung laeuft
       gebuendelt im naechsten Frame, damit ein Renderlauf mit vielen
       Knoten nur einmal Arbeit ausloest.

       Beobachtet wird nur childList, nicht attributes - sonst wuerde die
       Korrektur oben sich selbst erneut ausloesen. */
    if (window.MutationObserver) {
      var pending = false;
      new MutationObserver(function () {
        if (pending) return;
        pending = true;
        window.requestAnimationFrame(function () {
          pending = false;
          paint(current());
        });
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
